export default "__VITE_ASSET__5db2946a__"